<div style="background-color: #f5f5f6; padding-top: 35px;">
    <div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto">
        <div class="row no-gutters col-12">
            <div class="row no-gutters col-12 border-bottom">
                <div class="col-md-12 col-xl-6">
                    <div class="text-logo-footer pb-3 d-none d-sm-block">
                        <img src="../../../../assets/images/ge-vernova-logo.svg" alt="" style="padding-right: 7px; width: 200px;">
                    </div>
                    <div class="text-logo-footer pb-3 d-block d-sm-none">
                        <img src="../../../../assets/images/ge-vernova-logo.svg" alt="">
                    </div>
                    <p class="d-none d-md-block text-footer margin-left">
                        For additional GE Vernova information go to 
                        <a href="https://www.gevernova.com"
                            aria-label="Footter Links" target="_blank">
                            www.gevernova.com
                        </a>
                    </p>
                </div>
                <!-- <div class="row no-gutters justify-content-center col-md-12 col-xl-4">
                    <div class="col-md-6 col-sm-6 col-6 col-xl-4">
                        <div class="text-header-footer pb-3">
                            SOLUTION
                        </div>
                        <ul class="list-unstyled text-footer margin-left">
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/wind-energy"
                                    aria-label="Footter Links">
                                    Wind
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/hydro-power"
                                    aria-label="Footter Links">
                                    Hydro
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/hybrid"
                                    aria-label="Footter Links">
                                    Hybrid
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.gegridsolutions.com/" aria-label="Footter Links">
                                    Grid
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/digital-solutions"
                                    aria-label="Footter Links">
                                    Digital
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/services"
                                    aria-label="Footter Links">
                                    Services
                                </a>
                            </li>
                        </ul>

                    </div>
                    <div class="col-md-6 col-sm-6 col-6 col-xl-4">
                        <div class="text-header-footer pb-3">
                            ABOUT US
                        </div>
                        <ul class="list-unstyled text-footer margin-left">
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/about-us/carbon-neutral"
                                    aria-label="Footter Links">
                                    Carbon neutral
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/newsroom"
                                    aria-label="Footter Links">
                                    Newsroom
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/about-us/careers"
                                    aria-label="Footter Links">
                                    Careers
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/about-us/meet-our-executives"
                                    aria-label="Footter Links">
                                    Leadership Team
                                </a>
                            </li>
                            <li class="nav-item ">
                                <a href="https://www.ge.com/renewableenergy/suppliers"
                                    aria-label="Footter Links">
                                    Suppliers
                                </a>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <!-- <div class="footer_links followus_links col-lg-2 col-xl-2 col-md-3">
                    <div id="block-footermenuright">
                        <div class="text-header-footer pb-4">
                            FOLLOW US
                        </div>
                        <ul class="list-unstyled row no-gutters no-px col-12 text-footer">
                            <li class="col">
                                <a aria-label="Footter Links" href="https://www.facebook.com/gerenewableenergy">
                                    <i class="fa fa-facebook border-circle-face" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="col">
                                <a aria-label="Footter Links" href="https://twitter.com/GErenewables">
                                    <i class="fa fa-twitter border-circle" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="col">
                                <a aria-label="Footter Links" href="https://www.instagram.com/gerenewableenergy">
                                    <i class="fa fa-instagram border-circle" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="col">
                                <a aria-label="Footter Links"
                                    href="https://www.linkedin.com/company/gerenewableenergy/">
                                    <i class="fa fa-linkedin-square border-circle" aria-hidden="true">
                                    </i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <br>
            </div>
            <div class="row no-gutters col-12 pt-3">
                <ul class="list-unstyled col-12 row justify-content-end text-footer">
                    <!-- <li class="col-sm-12 col-md-auto col-xl-auto"><a aria-label="Footter Links"
                            href="https://www.ge.com/privacy">Privacy </a></li> -->
                    <!-- <li class="col-sm-12 col-md-auto col-xl-auto"><a aria-label="Footter Links" href="#"
                        (click)="event.preventDefault(); window.evidon.notice.showConsentTool();">Cookies </a>
                    </li> -->
                    <!-- <li class="col-sm-12 col-md-auto col-xl-auto"><a aria-label="Footter Links"
                            href="https://www.ge.com/renewableenergy/terms-conditions">Terms
                            &amp;
                            Conditions
                        </a></li>
                    <li class="col-sm-12 col-md-auto col-xl-auto"><a aria-label="Footter Links"
                            href="https://www.ge.com/renewableenergy/sitemap">Sitemap </a></li>
                    <li class="col-sm-12 col-md-auto col-xl-auto"><a aria-label="Footter Links"
                            href="https://info.gepower.com/Preference-Center-Login-LP.html">Preferences </a></li> -->
                    <li class="col-sm-12 col-md-12 col-xl-12 text-xl-center text-sm-center">© {{year}} GE Vernova and/or its affiliates. All rights reserved.</li>
                </ul>
            </div>
        </div>
    </div>
</div>